import { gql } from '@apollo/client';

const customer = {
  CUSTOMER_DETAILS: gql`
    fragment CustomerDetails on Customer {
      salutation
      firstName
      lastName
      phone
      email
      identificationNumber
      marketingInformation
    }
  `,
};

export default customer;
